(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/racing-game/components/play/assets/javascripts/pickers/game-type-picker.js') >= 0) return;  svs.modules.push('/modules/racing-game/components/play/assets/javascripts/pickers/game-type-picker.js');

'use strict';

const {
  getProductName,
  getGameTypeHelpShort,
  getGameTypeHelpHeader
} = svs.racing.common.strings;
const {
  ReactIcon,
  ReactIconButton
} = svs.ui;
const RadioGroup = svs.ui.form.RadioGroup;
const RadioButton = svs.ui.form.RadioButton;
const drawNotYetOpen = svs.racing.common.statusUtil.drawNotYetOpen;
const raceNoLongerOpen = svs.racing.common.statusUtil.raceNoLongerOpen;
const raceHasPreliminaryResults = svs.racing.common.statusUtil.raceHasPreliminaryResults;
const raceHasFinalResults = svs.racing.common.statusUtil.raceHasFinalResults;
const NetSales = svs.racing.netsales.NetSales;
const getHelpTexts = draws => {
  const gameTypeExplanations = [];
  draws.forEach(draw => {
    const help = svs.racing_game.data.racingconfig.helpTexts && svs.racing_game.data.racingconfig.helpTexts.gametypes && svs.racing_game.data.racingconfig.helpTexts.gametypes[draw.gameType];
    if (help) {
      gameTypeExplanations.push({
        type: svs.components.dialog.message.TEXT,
        text: "<span class=\"f-bold\">".concat(getProductName(draw.gameType), "</span> - ").concat(help.text),
        align: svs.components.dialog.message.align.LEFT
      });
    }
  });
  return gameTypeExplanations;
};
const handleHelpButtonClick = (e, draws) => {
  svs.components.dialog.api.add(new svs.components.dialog.Confirm({
    branding: svs.components.dialog.branding.SPORT,
    icon: 'help',
    type: svs.components.dialog.type.INFO,
    title: 'Spelformer',
    message: getHelpTexts(draws),
    actions: [{
      title: 'stäng'
    }]
  }));
};
const getCashbackHeader = race => {
  if (race) {
    if (raceNoLongerOpen(race)) {
      if (raceHasFinalResults(race)) {
        return React.createElement("div", {
          className: "cashback-header"
        }, "Utdelning");
      } else if (raceHasPreliminaryResults(race)) {
        return React.createElement("div", {
          className: "cashback-header"
        }, "Prelimin\xE4r utdelning");
      }
    }
  }
  return '';
};
const renderNetsales = (currentDraw, race) => {
  if (currentDraw) {
    const netsales = React.createElement(NetSales, {
      currentDraw: currentDraw,
      race: race
    });
    if (netsales) {
      return netsales;
    }
  }
  return null;
};
const renderGameTypeDescription = gameType => React.createElement("div", {
  className: "gametype-short-description"
}, React.createElement("div", {
  className: "heading"
}, getGameTypeHelpHeader(gameType)), React.createElement("div", {
  className: "paragraph"
}, getGameTypeHelpShort(gameType)));
const GameTypePicker = _ref => {
  let {
    currentDraw,
    race,
    gameType,
    setGameType,
    marketplaceAccount
  } = _ref;
  const draws = (race === null || race === void 0 ? void 0 : race.draws) || [];
  return React.createElement("div", {
    className: "game-type-picker-holder"
  }, getCashbackHeader(race), React.createElement("div", {
    className: "picker-header"
  }, React.createElement("span", null, "V\xE4lj spelform"), React.createElement(ReactIconButton, {
    className: "align-bottom icon-button padding-xs-h",
    onClick: e => handleHelpButtonClick(e, draws),
    type: "button"
  }, React.createElement(ReactIcon, {
    color: "fc-sport",
    icon: "help",
    size: "300"
  }))), React.createElement("div", {
    className: "game-type-picker form-toggle-racing"
  }, React.createElement(RadioGroup, {
    className: "margin-xs-bottom-1 game-type-picker-radio-group",
    multipleLines: true,
    size: "200",
    thin: true
  }, draws.map(draw => React.createElement(RadioButton, {
    branding: "racing",
    checked: draw.gameType === gameType,
    disabled: drawNotYetOpen(draw) || marketplaceAccount,
    key: draw.gameType,
    onChange: () => setGameType(draw.gameType),
    value: draw.gameType
  }, getProductName(draw.gameType)))), renderGameTypeDescription(gameType), renderNetsales(currentDraw, race)));
};
svs.racing_game.components.play.GameTypePicker = GameTypePicker;

 })(window);